import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoraEmptySparkle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 30 30",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 4.5C15.663 10.0292 19.9708 14.337 25.5 15C19.9708 15.663 15.663 19.9708 15 25.5C14.337 19.9708 10.0292 15.663 4.5 15C10.0292 14.337 14.337 10.0292 15 4.5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNoraEmptySparkle;
